var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
    _c("div", { staticClass: "zone_info" }, [
      _c("div", { staticClass: "feature_info" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _vm.obj_to_null(_vm.active_feature)
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "basic-url" } },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__t("ZONE_COST")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c(
                        "span",
                        {
                          staticClass: "input-group-text",
                          attrs: { id: "basic-addon3" },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.active_feature.id) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.feature_cost,
                          expression: "feature_cost",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        id: "basic-url",
                        "aria-describedby": "basic-addon3",
                      },
                      domProps: { value: _vm.feature_cost },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.feature_cost = $event.target.value
                        },
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _vm.obj_to_null(_vm.active_feature)
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "basic-url" } },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__t("ZONE_TIME")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c(
                        "span",
                        {
                          staticClass: "input-group-text",
                          attrs: { id: "basic-addon4" },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.active_feature.id) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.feature_time,
                          expression: "feature_time",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        id: "basic-url4",
                        "aria-describedby": "basic-addon3",
                      },
                      domProps: { value: _vm.feature_time },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.feature_time = $event.target.value
                        },
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rest_zones" }, [
      _c("div", { ref: "map", staticClass: "map" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }